export function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold text-brand-midnight border-b border-gray-100 pb-2">{title}</h2>
      {children}
    </section>
  )
}
